import {
    USERS_FETCH,
    USER_FETCH_BY_ID,
    USER_ADD_POINT,
    USER_SOCIAL_CHECK,
    USER_POINT_FETCH
} from '../actions/types';

const INITIAL_STATE = { 
    users: null,
    user: null,
    showAlert: false,
    loadingSocial: true,
    points: null
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case USERS_FETCH:
            return { ...state, users: action.payload }
        case USER_FETCH_BY_ID:
            return { ...state, user: action.payload }
        case USER_ADD_POINT:
            return { ...state, showAlert: action.payload }
        case USER_SOCIAL_CHECK:
            return { ...state, loadingSocial: action.payload }
        case USER_POINT_FETCH:
            return { ...state, points: action.payload }
        default:
			return state;
	}
}